import { Api } from "./Api";
import Cookies from "js-cookie";
import {
  User,
  UserWithSubscriptions,
  UpdateUserBody,
  UpdatePasswordBody,
  CreateUserBody,
  UserSubscription,
  SubscriptionCount,
} from "./types";

export const UserApi = {
  async getMe() {
    try {
      const { data: response } = await Api.get<{ payload?: User }>(
        `/users/get-me`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getAllUsers() {
    try {
      const { data: response } = await Api.get<{
        payload?: UserWithSubscriptions[];
      }>(`/users/get-all`);
      return response ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getUserById(id: number) {
    try {
      const { data: response } = await Api.get<{
        payload?: UserWithSubscriptions;
      }>(`/users/get-user/${id}`);
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async updateUser(id: number, userData: UpdateUserBody) {
    try {
      const { data: response } = await Api.patch(
        `/users/${id}/update`,
        userData
      );
      return response ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async updatePassword(passwordData: UpdatePasswordBody) {
    try {
      const { data: response } = await Api.patch(
        `/users/update-password`,
        passwordData
      );
      return response ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async createAccount(data: CreateUserBody) {
    try {
      const { data: response } = await Api.post(`/users/create-account`, data);
      const token = response.payload.access_token;
      if (token) {
        Cookies.set("token", token, { secure: true, sameSite: "Strict" });
      }
      return response ?? null;
    } catch (error) {
      return error;
    }
  },

  async getMySubscriptionData() {
    try {
      const { data: response } = await Api.get<{
        payload?: UserSubscription[];
      }>("/users/get-my-subscriptions");
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },

  async getSubscriptionCount() {
    try {
      const { data: response } = await Api.get<{ payload?: SubscriptionCount }>(
        "/users/subscription-status"
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteUser(id: number) {
    try {
      const { data: response } = await Api.delete(`/users/${id}/delete`);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteMultipleUsers(userIds: number[]) {
    try {
      const { data: response } = await Api.post("/users/delete-multiple", {
        userIds,
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
};
